import uuid from '@/common/utils/uuid';

export default {
  create() {
    return uuid();
  }
};
